
import React from "react";

import InfiniteScroll from "react-infinite-scroll-component";
import moment from 'moment'

import SojTerrainLocationSVPriceListView from '../../sojterrain/SojTerrainLocationSVPriceListView'
 
const style = {
    height: 30,
    border: "1px solid red",
    margin: 6,
    padding: 8
  };

  
class SJScroll extends React.Component{
    componentDidMount(){
        //length is 5 
        //we neeed to concat
        console.log('SV**JUN13*****componentDidMount*******availMore START')
        console.log(this.props.my_data)
        console.log('SV**JUN13*****componentDidMount*******availMore END')
        let ps = this.props.my_data ? this.props.my_data.length : 5
        let ar = Array.from({length:ps})
        this.setState({
            items:ar
        })
    }
    /*
    componentDidUpdate(){
        //we have new props 
        console.log('SV**JUN13*****componentDidUpdate*******availMore START')
        console.log(this.props.my_data)
        console.log('SV**JUN13*****componentDidUpdate*******availMore END')
        let ps = this.props.my_data ? this.props.my_data.length : 5

        let ptotal = ps + this.state.items.length
        console.log('total', ptotal)
        this.setState({
            items: this.state.items.concat(Array.from({ length: ptotal }))
          });
    }
    */
    
    /*
    sojAndImagesSojournMoreNow(sojPostPaginateRqMore, sv_esquery_data){
        console.log('SV**JUN13*****SJScroll*******availMore called')
        let {ntimes} = this.state
        if (this.state.items.length >= 500) {
            this.setState({ hasMore: false });
            return;
        }
        ntimes = ntimes + 1;
        console.log('SV**JUN13*****SJScroll*******availMore  ntimes: ',ntimes)
        setTimeout((sojPostPaginateRqMore, sv_esquery_data) => {
            console.log(sojPostPaginateRqMore)
            console.log(sv_esquery_data)
            if(sv_esquery_data){
                this.props.sojAndImagesSojournMore(sojPostPaginateRqMore, sv_esquery_data)
            }
          
          }, 1000);
        
    }
    */
  
    fetchMoreData = () => {
        console.log('SV**JUN13*****SJScroll*******fetchMoreData called')
        const{sv_esquery_data,my_scr_id} = this.props
       
        const {my_esqueryText,STARTDATE,ENDDATE,time_zone} =sv_esquery_data
        let startDate = STARTDATE
        let endDate = ENDDATE
        
        console.log('SJ Jun12InvSJScroll needs *** my_scr_id from reducer ',my_scr_id)
        let start_date_s   = moment(startDate).toISOString() 
    console.log("**formatISO***", start_date_s)

    let esqueryText = my_esqueryText ? my_esqueryText :'MCO' 
    let moEndDate = moment(endDate)
    let moStartDate = moment(startDate)
    let mo_es = moEndDate.format('YYYY-MM-DD') 
    let mo_ss = moStartDate.format('YYYY-MM-DD') 
    let end_date_s   = moment(endDate).toISOString() 
    console.log("**Jun12Y25**end_date_s and sv_esquery_data *", end_date_s)
    console.log(sv_esquery_data)
 if(!my_scr_id){
   console.log('FRAVE ERROR REDUCE SHOULD SUPPY my_scr_id ')
 }
    let sojPostPaginateRqMore= {
        "svfields": [
            "images",
            "sojourn_name",
            "address",
           
            "code",
            "sojournGeocode",
            "categoryCode",
            "categoryGroupCode",
            "accommodationTypeCode",
    
            "sojourn_city",
            "countryCode",
            "stateCode",
            "postalCode",
             "countryCode",
             "ranking",
             "web",
             "terminals",
            "destinationCode"
        ],
        "dates": {
            "STARTDATE_ITN_TZAWARE_EST": (mo_ss ? mo_ss: "2025-10-24" ),
            "ENDDATE_ITN_TZAWARE_EST": (mo_es ? mo_es: "2025-10-27" ),
            "DT_FORMAT": "%Y-%m-%d",
            "time_zone": "Asia/Kolkata",
            "OP": "range"
        },
        "facets": {
            "accommodationTypeCode": "H"
        },
        "useCity": false,
        "dst": esqueryText ? esqueryText : "BEVERLY HILLS",
    
        "esqueryChilds": "m0",
        "esqueryInfants": "i0",
        "esqueryAdults": "t1",
        "esqueryCabin": "ECONOMY",
        "esqueryTripType": "roundtrip",
        "svpageSize": 5,
        "codeKeys": [
               
            ],
        "destinationCode": esqueryText ? esqueryText : "BEVERLY HILLS",
        "esqueryRooms": "r1",

        "pagenumber":1,
        "my_scr_id": my_scr_id ? my_scr_id : ''
    }
     
       console.log('sojPostPaginateRqMore',sojPostPaginateRqMore)

        if (this.state.items.length >= 500) {
          this.setState({ hasMore: false });
          return;
        }
        // a fake async api call like which sends
        // 20 more records in .5 secs
        /*
          */
        this.props.sojAndImagesSojournMore(sojPostPaginateRqMore, sv_esquery_data)
     
        /*
        setTimeout(() => {
          this.setState({
            items: this.state.items.concat(Array.from({ length: 5 }))
          });
        }, 500);
        */
      };
    constructor(props){
        super(props);
        let me = this
        //this.updateItems = this.updateItems.bind(me)
       // this.sojAndImagesSojournMoreNow = this.sojAndImagesSojournMoreNow.bind(me)
        this.state = {
            items:Array.from({length:5}),
            ntimes:0,
            hasMore:true
        }
    }
  
    
    render() {
      /*
           let ptotal =  this.state.items.length
        */
      let ps = this.props.my_data ? this.props.my_data.length : 5

      let ptotal = ps + this.state.items.length
      

    
        console.log('total', ptotal)
        
     
        return (
          <div>
            <h1>demo: react-infinite-scroll-component</h1>
            <hr />
            const {}
            <InfiniteScroll
              dataLength={ptotal}
              next={this.fetchMoreData}
              hasMore={this.state.hasMore}
              loader={<h4>Loading...</h4>}
              endMessage={
                <p style={{ textAlign: "center" }}>
                  <b>Yay! You have seen it all</b>
                </p>
              }
            >
            
              {this.state.items.map((i, index) => (
                <div style={style} key={index}>
                  div - #{index}
                </div>
              ))}
            </InfiniteScroll>
          </div>
        );
      }
}
//invBoardBodyPgListScroll.js
export default SJScroll

/*


    render() {
        return (
          <div>
            <h1>demo: react-infinite-scroll-component</h1>
            <hr />
            <InfiniteScroll
              dataLength={this.state.items.length}
              next={this.fetchMoreData}
              hasMore={this.state.hasMore}
              loader={<h4>Loading...</h4>}
              endMessage={
                <p style={{ textAlign: "center" }}>
                  <b>Yay! You have seen it all</b>
                </p>
              }
            >
            
              {this.state.items.map((i, index) => (
                <div style={style} key={index}>
                  div - #{index}
                </div>
              ))}
            </InfiniteScroll>
          </div>
        );
      }
}

 fetchMoreData = () => {
        console.log('SV**JUN13*****SJScroll*******fetchMoreData called')
        const{sv_esquery_data} = this.props
       
        const {my_esqueryText,my_scr_id,STARTDATE,ENDDATE,time_zone} =sv_esquery_data
        let startDate = STARTDATE
        let endDate = ENDDATE
        
        console.log('SJ Jun12InvSJScroll needs *** my_scr_id from reducer ',my_scr_id)
        let start_date_s   = moment(startDate).toISOString() 
    console.log("**formatISO***", start_date_s)

    let esqueryText = my_esqueryText ? my_esqueryText :'MCO' 
    let moEndDate = moment(endDate)
    let moStartDate = moment(startDate)
    let mo_es = moEndDate.format('YYYY-MM-DD') 
    let mo_ss = moStartDate.format('YYYY-MM-DD') 
    let end_date_s   = moment(endDate).toISOString() 
    console.log("**Jun12Y25**end_date_s and sv_esquery_data *", end_date_s)
    console.log(sv_esquery_data)
 if(!my_scr_id){
   console.log('FRAVE ERROR REDUCE SHOULD SUPPY my_scr_id ')
 }
    let sojPostPaginateRqMore= {
        "svfields": [
            "images",
            "sojourn_name",
            "address",
           
            "code",
            "sojournGeocode",
            "categoryCode",
            "categoryGroupCode",
            "accommodationTypeCode",
    
            "sojourn_city",
            "countryCode",
            "stateCode",
            "postalCode",
             "countryCode",
             "ranking",
             "web",
             "terminals",
            "destinationCode"
        ],
        "dates": {
            "STARTDATE_ITN_TZAWARE_EST": (mo_ss ? mo_ss: "2025-10-24" ),
            "ENDDATE_ITN_TZAWARE_EST": (mo_es ? mo_es: "2025-10-27" ),
            "DT_FORMAT": "%Y-%m-%d",
            "time_zone": "Asia/Kolkata",
            "OP": "range"
        },
        "facets": {
            "accommodationTypeCode": "H"
        },
        "useCity": false,
        "dst": esqueryText ? esqueryText : "BEVERLY HILLS",
    
        "esqueryChilds": "m0",
        "esqueryInfants": "i0",
        "esqueryAdults": "t1",
        "esqueryCabin": "ECONOMY",
        "esqueryTripType": "roundtrip",
        "svpageSize": 5,
        "codeKeys": [
               
            ],
        "destinationCode": esqueryText ? esqueryText : "BEVERLY HILLS",
        "esqueryRooms": "r1",

        "pagenumber":1,
        "my_scr_id": my_scr_id ? my_scr_id : ''
    }
     
       console.log('sojPostPaginateRqMore',sojPostPaginateRqMore)

        if (this.state.items.length >= 500) {
          this.setState({ hasMore: false });
          return;
        }
        // a fake async api call like which sends
        // 20 more records in .5 secs
        setTimeout(() => {
          this.setState({
            items: this.state.items.concat(Array.from({ length: 5 }))
          });
        }, 500);
      };

*/

 /*
 fetchMoreData = () => {
        console.log('SV**JUN13*****SJScroll*******fetchMoreData called')
        if (this.state.items.length >= 500) {
          this.setState({ hasMore: false });
          return;
        }
        // a fake async api call like which sends
        // 20 more records in .5 secs
        setTimeout(() => {
          this.setState({
            items: this.state.items.concat(Array.from({ length: 5 }))
          });
        }, 500);
      };
    constructor(props){
        super(props);
        let me = this
        //this.updateItems = this.updateItems.bind(me)
       // this.sojAndImagesSojournMoreNow = this.sojAndImagesSojournMoreNow.bind(me)
        this.state = {
            items:Array.from({length:5}),
            ntimes:0,
            hasMore:true
        }
    }
   */